import { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopHeader from './components/TopHeader';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Preloader from './components/Preloader';
import Home from './pages/Home';
import About from './pages/About';
import Admissions from './pages/Admissions';
import Academics from './pages/Academics';
import Faculty from './pages/Faculty';
import MandatoryDisclosures from './pages/MandatoryDisclosures';
import Contact from './pages/Contact';
import Slc from './pages/Slc';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [showPreloader, setShowPreloader] = useState(true);
  const handlePreloaderDone = useCallback(() => setShowPreloader(false), []);

  return (
    <Router>
      <ScrollToTop />
      {showPreloader && <Preloader onComplete={handlePreloaderDone} />}
      <div className="flex flex-col min-h-screen">
        <header className="sticky top-0 z-50">
          <TopHeader />
          <Navigation />
        </header>
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/faculty" element={<Faculty />} />
            <Route path="/mandatory-disclosures" element={<MandatoryDisclosures />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/slc" element={<Slc />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
